class ContentTabs extends HTMLElement {
    activeTabId = ''
    tabLabels = []
    activeTabIndicator
    activeTabLabel
    tabsContent = []

    constructor() {
        super();
    }

    connectedCallback() {
        this.tabLabels = this.querySelectorAll('.content-tabs__label');
        this.activeTabId = this.tabLabels[0]?.id || '';
        this.activeTabIndicator = this.querySelector('.content-tabs__active-indicator');
        this.activeTabLabel = this.tabLabels[0]
        this.tabsContent = this.querySelectorAll('[data-active-collection]');

        this.tabLabels.forEach(label => label.addEventListener('click', this.onLabelClick));
        this.setActiveTab(this.activeTabId)

        if (this.activeTabIndicator) {
            window.addEventListener('resize', () => this.adjustIndicatorPosition(this.activeTabLabel))
            this.adjustIndicatorPosition(this.activeTabLabel)
        }
    }

    onLabelClick = (event) => {
        this.activeTabId = event.target.id
        this.activeTabLabel = event.target

        this.setActiveTab(this.activeTabId)
    }

    adjustIndicatorPosition = (label) => {
        const labelBoundaries = label.getBoundingClientRect()

        this.activeTabIndicator.style.width = labelBoundaries.width + 'px'
        this.activeTabIndicator.style.left = label.offsetLeft + 'px'
        this.activeTabIndicator.style.top = label.offsetTop + labelBoundaries.height + 6 + 'px'
    }

    setActiveTab(id) {
        this.tabLabels.forEach((label) => {
            label.classList.remove('content-tabs__label--active');

            if (label.id === id) {
                label.classList.add('content-tabs__label--active');

                if (this.activeTabIndicator) {
                    this.adjustIndicatorPosition(label)
                }
            }
        });

        this.tabsContent.forEach((tabContent) => {
            tabContent.classList.add('hidden');

            if (tabContent.dataset.activeCollection === id) {
                tabContent.classList.remove('hidden');
            }
        })
    }
}

customElements.define('content-tabs', ContentTabs);
